export default __webpack_public_path__ + "static/media/Mall Music Muzak - Mall Of 1974 - 05 Grocery Grabbing.346a60e3.mp3";